<div class="dialoghead">
  <h1 class="mat-mdc-dialog-title">{{cookieData?.userinfo?.perennial_mandalism_status && cookieData?.userinfo?.perennial_mandalism_status !== 'subscription running' ?
    'Subscription Expired' : 'Payment'}}</h1>
  <mat-dialog-content *ngIf="cookieData?.userinfo?.perennial_mandalism_status && cookieData?.userinfo?.perennial_mandalism_status !== 'subscription running'">
    <p>Your subscription to the <strong>Perennial Mandalism Dashboard</strong> ended on <strong>{{
        cookieData?.userinfo?.perennial_current_period_end | date:'EEEE, MMMM d, y' }}</strong>.
      <br>To regain access to your dashboard, its guided practices for mandala creation and contemplation, insights into
      their timeless wisdom, and all other member resources, please renew your subscription below.
    </p>
  </mat-dialog-content>
  <mat-dialog-content>
    <form *ngIf="mode === 'payment'" (submit)="handleSubmit($event)">
      <div id="perennial-payment-element" class="mystery_payment_form"></div>
      <mat-dialog-actions>
        <button mat-button type="submit">Pay & Subscribe</button>
      </mat-dialog-actions>
      <ng-container *ngIf="isLoading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-container>
    </form>
    <form *ngIf="mode === 'setup'" (submit)="handleSetupSubmit($event)">
      <div id="perennial-payment-element" class="mystery_payment_form"></div>
      <mat-dialog-actions>
        <button mat-button type="submit">Pay & Subscribe</button>
      </mat-dialog-actions>
      <ng-container *ngIf="isLoading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-container>
    </form>
    <div *ngIf="mode === 'noClientSecret'">
      <p>You already have access until {{ cookieData.userinfo.perennial_current_period_end| date:'mediumDate' }}.
        Your subscription has been renewed and will continue without interruption.</p>
    </div>

    <div *ngIf="!mode">
      <p>Initializing payment form...</p>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  </mat-dialog-content>
</div>